import React from 'react'

const Welcome = () => {
  return (
    <div className='w-full h-full  text-2xl text-green-300 mt-64 absolute text-center'>
        <div className=' ml-48 rounded-md h-32 w-96  mt-16'>
        Hi, Glad to meet You.........
        </div>
      

    </div>
  )
}

export default Welcome